import { contextFactory } from '@frontend/design-system';
import { UseFreemiumResults } from './types';

const initialFreemiumContextValue: UseFreemiumResults = {
  isFreemium: false,
  freemiumLocationIds: [],
  isActionBlocked: () => false,
  featureUpgradeDetailsModalControls: {
    openModal: () => {},
    closeModal: () => {},
    modalProps: { onClose: () => {}, show: false },
    triggerProps: { onClick: () => {}, ref: null },
  },
};

export const [DigitalFormsFreemiumContext, useDigitalFormsFreemiumContext] = contextFactory<UseFreemiumResults>(
  'useDigitalFormsFreemiumContext must be used within a DigitalFormsFreemiumContext',
  initialFreemiumContextValue
);
